import {
  RequestQuote,
  Email,
  Add as AddIcon,
} from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import { useState } from "react";
import { useHasPermission } from "../../contexts/auth";
import { SettlementCreator } from "../../components/settlements/settlementCreator/settlementCreator.component";
import { SendReminder } from "../../components/settlements/sendReminder/sendReminder.component";
import EquipmentCounterForm from "../../components/ui/equipmentCounterForm/equipmentCounterForm.component";

export const SettlementsActions = () => {
  const { t } = useTranslation();
  const [generateSettlementOpened, setGenerateSettlementOpened] = useState<boolean>(false);
  const [sendReminderOpened, setSendReminderOpened] = useState<boolean>(false);
  const [addCounterOpened, setAddCounterOpened] = useState<boolean>(false);
  const canAddSettlement = useHasPermission("settlement.add_settlement");
  const canChangeSettlement = useHasPermission("settlement.change_settlement");
  const canAddCounter = useHasPermission("settlement.add_equipmentcounter");

  const actions: Action[] = [
    {
      icon: <RequestQuote />,
      label: t("Settlement Creator"),
      onClick: () => { setGenerateSettlementOpened(true) },
      disabled: !canAddSettlement
    },
    {
      icon: <Email />,
      label: t("Send reminder"),
      onClick: () => { setSendReminderOpened(true) },
      disabled: !canChangeSettlement
    },
    {
      id: "add-new-counter",
      icon: <AddIcon />,
      label: t("Add new counter"),
      onClick: () => { setAddCounterOpened(true); },
      disabled: !canAddCounter,
    },
  ];

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={generateSettlementOpened}
        setOpened={setGenerateSettlementOpened}
        title={t("Settlement Creator")}
        content={
          <SettlementCreator
            onSuccess={() => setGenerateSettlementOpened(false)}
          />
        }
        width="min(1040px, 94vw)"
      />
      <CustomModal
        opened={sendReminderOpened}
        setOpened={setSendReminderOpened}
        title={t("Send reminder")}
        content={
          <SendReminder
            onSuccess={() => {
              setSendReminderOpened(false);
              window.dispatchEvent(new Event("settlementUpdated"));
            }}
          />
        }
      />
      <CustomModal
        opened={addCounterOpened}
        setOpened={setAddCounterOpened}
        title={t("Add new counter")}
        content={
          <EquipmentCounterForm
            onSuccess={() => {
              setAddCounterOpened(false);
              window.dispatchEvent(new Event("equipmentCounterAdded"));
            }}
            hiddenFields={["job"]}
          />
        }
      />
    </>
  );
};
